'use client'

import type { ModelsPlatformStatsResponse } from '@/api/generated-api'
import { useSectionFooterOverflowMargin } from '@/hooks/useSectionFooterOverflowMargin'

import FansHeroIntro from './FansHeroIntro'
import { FANS_SECTION_FOOTER_GAP_PX } from './fansLandingContent.constants'
import S from './FansLandingContent.module.scss'
import FansRewardsWays from './FansRewardsWays'
import FansSimpleProcess from './FansSimpleProcess/FansSimpleProcess'
import FansStadiumCta from './FansStadiumCta'
import FansStatsBar from './FansStatsBar'
import FansWhyJoinArena from './FansWhyJoinArena/FansWhyJoinArena'

const FansLandingContent = ({
  initialStats
}: {
  initialStats?: ModelsPlatformStatsResponse
}) => {
  const rootRef = useSectionFooterOverflowMargin(FANS_SECTION_FOOTER_GAP_PX)

  return (
    <div ref={rootRef} className={S.root}>
      <FansHeroIntro />
      <FansStatsBar initialStats={initialStats} />
      <div id="fans-simple-process" className={S.simpleProcessBlock}>
        <FansSimpleProcess />
        <FansRewardsWays />
        <div className={S.redDotBlock}>
          <FansWhyJoinArena />
          <FansStadiumCta />
        </div>
      </div>
    </div>
  )
}

export default FansLandingContent
